export class VersionHistoryFilterModel {
    id: number;
    versionId: number;
    filterType: string;
    templateNo:number;

    constructor() {
        this.id = 0;
        this.versionId = 0;
        this.filterType = '';
        this.templateNo = 0;
    }
}
